export interface PurchaseOrderStatus {
  id: string;
  description: string;
  colour: string;
}
